import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import TitleSection from "src/components/TitleSection/TitleSection";
import EventFinished from "src/components/EventFinished";

const LadiesNight2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <LadiesNight2025Div>
      <Hero
        bgImage={`promotions/gaming-machines/ladies-night-2025/ladies-night-hero-image-2400x800px.jpg`}
        buttonSettings={null}
        image={`promotions/gaming-machines/ladies-night-2025/ladies-night-2400x2400px-${i18n.language}.png`}
        darkenBg={0.5}
        title={t("ladiesNight2025.hero.desc")}
        titleAs="h2"
      />
      <EventFinished scheduleKeyName="ladiesNight2025" eventType="promotion" />
      <MainContentDiv>
        <TitleSection
          as={"h3"}
          title={t("ladiesNight2025.content.title")}
          text={t("ladiesNight2025.content.desc")}
        />
        <BarPromoTitle>
          {t("ladiesNight2025.barPromotions.title")}
        </BarPromoTitle>
        <container-div>
          <Row className="g-5 mt-0 align-items-center justify-content-center flex-column-reverse flex-md-row">
            <Col md={5} xs={12}>
              <PromoContent>
                <ReactMarkdown>{t("ladiesNight2025.speedRail")}</ReactMarkdown>
                <ReactMarkdown>
                  {t("ladiesNight2025.featuredCocktails")}
                </ReactMarkdown>
                <ReactMarkdown>{t("ladiesNight2025.wineBeer")}</ReactMarkdown>
              </PromoContent>
            </Col>
            <Col md={5} xs={12}>
              <ResponsiveImage
                src={`promotions/gaming-machines/ladies-night-2025/bartender.png`}
                alt="Bar Promotions"
              />
            </Col>
          </Row>
          <Row className="g-5 mt-0 mt-md-4 align-items-center justify-content-center">
            <Col md={5} xs={12}>
              <ResponsiveImage
                src="promotions/gaming-machines/ladies-night-2025/girls.png"
                alt="Ladies Night"
              />
            </Col>
            <Col md={5} xs={12}>
              <PromoContent>
                <ReactMarkdown>
                  {t("ladiesNight2025.entertainment")}
                </ReactMarkdown>
              </PromoContent>
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </LadiesNight2025Div>
  );
};

const LadiesNight2025Div = styled.div`
  width: 100%;
  background: var(--lightblack);
  color: var(--white);
  .hero_text_container {
    background-color: none;
    background: #e60392 !important;
    h2 {
      font-size: 1.7rem !important;
      text-shadow: none;
    }
  }
  .title-section {
    h3 {
      margin-bottom: 24px;
    }
    span {
      display: none;
    }
    @media (max-width: 768px) {
    h3 {
      font-size: 1.8rem;
    }
  }
  }
`;

const MainContentDiv = styled.div`
  width: 100%;
  padding: 40px 0;
`;

const BarPromoTitle = styled.h2`
  color: var(--white);
  text-align: center;
  font-size: 1.7rem;
  font-weight: 700;
  letter-spacing: 1px;
  background-color: #c500fe;
  text-align: center;
  padding: 20px;
`;

const PromoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  h4 {
    color: #f1059c;
    font-weight: bold;
  }
  @media (max-width: 768px) {
    h4 {
      font-size: 1.2rem;
    }
  }
`;

export default LadiesNight2025;
